module.exports = __webpack_public_path__ + "static/media/05.Kala Chethana Award - Bhaskar Kogga Kamath.9399427f.jpg";